import Vue from 'vue'
import moment from 'moment'

Vue.filter('formatDate', function(value) {
    if (value) {
        return moment(String(value)).format('DD/MM/YYYY - hh:mm')
    }
});



// WEBPACK FOOTER //
// ./src/filtres/index.js